import type {AgentRow} from '@/forecast-app/shared/components/agentic-workers/agentDeclaration';

// Where agents can appear on the invoicing pages. Each page passes its own id to the agent toolbar, and an
// agent declaration lists the ids it appears on.
export const INVOICING_AGENT_PAGE = {
	INVOICE_CREATION: 'INVOICE_CREATION',
	ALL_INVOICES: 'ALL_INVOICES',
} as const;

export const INVOICING_AGENT_ROW_TYPE = {
	PROJECT_BILLING_ROW: 'PROJECT_BILLING_ROW',
	RETAINER_PERIOD_ROW: 'RETAINER_PERIOD_ROW',
} as const;

export const projectBillingAgentRow = (projectId: number): AgentRow => ({
	rowType: INVOICING_AGENT_ROW_TYPE.PROJECT_BILLING_ROW,
	rowId: projectId,
});
